// ✅ src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDTQ4XwTyt8MKCMgZFhOWbMFESE9h_hick",
  authDomain: "onlinelearning-a12cc.firebaseapp.com",
  projectId: "onlinelearning-a12cc",
  storageBucket: "onlinelearning-a12cc.firebasestorage.app",
  messagingSenderId: "330064751649",
  appId: "1:330064751649:web:bc8d81f94caff40ca04760"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
